
import Vue from 'vue';
import Component from 'vue-class-component';
import SmoothReflow from 'vue-smooth-reflow';
import StepService from '@/services/StepService';
import ChargingStationService from '@/services/ChargingStationService';
import ISubStepDefinition from '@/interfaces/SubStepDefinition';
import ICustomRouteConfig from '@/router/interfaces/CustomRouteConfig';
import Modal from '@/components/Modal.vue';
import EventBus from '@/EventBus';
import {GlobalEvent} from '@/events';

@Component({
	name: 'Step',
	components: {Modal},
	mixins: [SmoothReflow]
})
export default class Step extends Vue
{
	private subStepIndex = 0;

	private transition = 'slide-up';

	private mounted()
	{
		this.$smoothReflow();

		EventBus.$on(GlobalEvent.ShowChargingStationError, () => this.showChargingStationErrorModal());
	}

	private get supportContact()
	{
		return this.$store.state.api.config.supportContact;
	}

	private get accessibleSubSteps(): ISubStepDefinition[]
	{
		// 2021-12-27 mr: added "as unknown" because they introduced a RouteMeta type interface in vue-router 3.5.2, which seems to be incompatible with our route.meta implementation
		// see https://github.com/vuejs/vue-router/pull/3385
		return StepService.getAccessibleSubSteps(this.$route as unknown as ICustomRouteConfig);
	}

	private onPreviousSubStep()
	{
		if (this.subStepIndex > 0)
		{
			this.transition = 'slide-down';

			this.subStepIndex--;
		}
	}

	private showChargingStationErrorModal()
	{
		this.$modal.show('charging-station-error');
	}

	private onNextSubStep()
	{
		if (!ChargingStationService.productsAvailable())
		{
			EventBus.$emit(GlobalEvent.ShowChargingStationError);
			return;
		}

		//if sub step is not the last sub step
		if ((this.subStepIndex + 1) < this.accessibleSubSteps.length)
		{
			this.transition = 'slide-up';

			this.subStepIndex++;
		}
		else
		{
			this.onNextStep();
		}
	}

	private onNextStep()
	{
		StepService.next();
	}

	private onRevertSelectionClicked()
	{
		this.$modal.hide('charging-station-error');
	}
}
